import Vue from "vue";
import Router from "vue-router";
import HomePage from "@/pages/HomePage";
import TaxesPage from "@/pages/TaxesPage";
import RegistrationPage from "@/pages/RegistrationPage";
import NewsPage from "@/pages/NewsPage";
import ContactPage from "@/pages/ContactPage";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/home",
      name: "HomePage",
      component: HomePage
    },
    {
      path: "/taxes",
      name: "Taxes",
      component: TaxesPage
    },
    {
      path: "/registration",
      name: "Registration",
      component: RegistrationPage
    },
    {
      path: "/news",
      name: "News",
      component: NewsPage
    },
    {
      path: "/contact_us",
      name: "ContactUs",
      component: ContactPage
    }
  ]
});
